import { jsx as _jsx } from "react/jsx-runtime";
import { StyledLink } from './StyledComponent';
export default function SupportLink(props) {
    const { text } = props;
    return _jsx(StyledLink, { to: "/support", children: text || 'Contact support' });
}
